import type { CurveOfTransition } from '../types';

export function linear(t: number) {
  return t;
}

export const easeInOut = (t: number) =>
  t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

export const easeOut = (t: number) => t * (2 - t);

export const matchCurve: Record<CurveOfTransition, Function> = {
  linear,
  easeInOut,
  easeOut
};
